import { render, staticRenderFns } from "./WeeklySchedule.vue?vue&type=template&id=985d514e&"
import script from "./WeeklySchedule.vue?vue&type=script&lang=js&"
export * from "./WeeklySchedule.vue?vue&type=script&lang=js&"
import style0 from "./WeeklySchedule.vue?vue&type=style&index=0&id=985d514e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports